import React from 'react';

export function ResizeHandle({ label, width, resizingRef, onResize, onReset }) {
  const onPointerDown = e => {
    e.preventDefault();
    e.stopPropagation();
    resizingRef.current = true;
    const startX = e.clientX;
    const startWidth = width;
    const move = ev => onResize(startWidth + ev.clientX - startX);
    const up = () => {
      resizingRef.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <span
      role="separator"
      aria-orientation="vertical"
      aria-label={`Resize ${label} column. Double-click to reset.`}
      aria-valuenow={width}
      tabIndex={0}
      draggable={false}
      onPointerDown={onPointerDown}
      onMouseDown={e => e.preventDefault()}
      onDoubleClick={onReset}
      onClick={e => e.stopPropagation()}
      onKeyDown={e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          onResize(width + (e.key === 'ArrowRight' ? 16 : -16));
        }
      }}
      className="tw-absolute -tw-right-1 tw-top-0 tw-z-[4] tw-flex tw-h-full tw-w-2.5 tw-cursor-col-resize tw-justify-center tw-outline-none after:tw-my-2 after:tw-w-0.5 after:tw-rounded-full after:tw-bg-brand-600 after:tw-opacity-0 after:tw-transition-opacity after:tw-duration-150 after:tw-content-[''] hover:after:tw-opacity-100 focus-visible:after:tw-opacity-100"
    />
  );
}
